import React from 'react';
import styled from 'styled-components';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';

import { Container } from '../../Hoc/elements';
import StickySidebar from '../../Components/Layout/StickySidebar';
import LeftJobSection from './LeftJobSection/LeftJobSection';
import NewJobSection from './NewJobSection/NewJobSection';

function NewJobs() {
  return (
    <Wrapper>
      <StyledContainer>
        <PageLayout>
          <StickySidebar>
            <LeftJobSection />
          </StickySidebar>

          <MainColumn>
            <PageHeader>
              <Badge><ExploreOutlinedIcon /> Explorer</Badge>
              <h1>Trouver un nouveau projet</h1>
            </PageHeader>
            <FeedCard><NewJobSection /></FeedCard>
          </MainColumn>
        </PageLayout>
      </StyledContainer>
    </Wrapper>
  );
}

const Wrapper = styled.main`
  width: 100%;
  min-height: calc(100vh - 5rem);
  padding: clamp(.8rem, 2vw, 1.5rem) 0 5rem;
  background: var(--color-background);
  color: var(--color-text);
`;

const StyledContainer = styled(Container)``;

const PageLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(17rem, 18rem) minmax(0, 1fr);
  gap: clamp(1rem, 2.4vw, 1.5rem);
  align-items: start;

  @media (max-width: 74rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const MainColumn = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 68rem;
  margin: 0 auto;
  align-self: start;
`;

const PageHeader = styled.header`
  margin-bottom: 1rem;
  padding: clamp(1rem, 2.5vw, 1.45rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: #fff;
  box-shadow: var(--shadow-xs);

  h1 { margin: .55rem 0 0; font-size: clamp(1.65rem, 4vw, 2.35rem); }
  p { max-width: 47rem; margin: .45rem 0 0; color: var(--color-muted); font-size: .9rem; }
`;

const Badge = styled.span`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: .38rem;
  padding: .35rem .62rem;
  border-radius: 999px;
  color: #5e482b;
  background: var(--color-accentSoft);
  font-size: .72rem;
  font-weight: 850;
  svg { font-size: 1rem; }
`;

const FeedCard = styled.section`
  width: 100%;
  padding: clamp(.55rem, 1.5vw, .85rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: #fff;
  box-shadow: var(--shadow-xs);
`;

export default NewJobs;
